import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Input,
  InputLabel,
  FormControl,
  Button,
  Typography,
  CircularProgress
} from "@material-ui/core";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import { resetPassword, resetForgotPasswordPage } from "./redux_actions";
import "../../components/LoginForm/LoginForm.css";

const toLogin = props => <Link to="/auth/login" {...props} />;
const toRegister = props => <Link to="/auth/register" {...props} />;

let ForgotPassword = class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = { email: "" };

    this.handleChange = event => {
      this.setState({ email: event.target.value });
    };

    // A real form submit, so Enter works as well as the button.
    this.handleSubmit = event => {
      event.preventDefault();
      this.props.resetPassword(this.state.email);
    };

    // "Use a different email" / "Send again": back to the form, email kept.
    this.tryAgain = () => {
      this.props.resetForgotPasswordPage();
    };
  }

  componentDidMount() {
    this.props.resetForgotPasswordPage();
  }

  renderForm() {
    const { resetPasswordInProgress, forgotPasswordErrorMsg } = this.props.auth;
    return (
      <form onSubmit={this.handleSubmit} noValidate className="loginform-cntr">
        <Typography gutterBottom>
          Enter the email address you use for ACP and we'll send you a link to set a new password.
        </Typography>
        <FormControl fullWidth className="input-cntr">
          <InputLabel htmlFor="reset-email">Email</InputLabel>
          <Input
            id="reset-email"
            name="email"
            type="email"
            autoComplete="email"
            autoFocus
            value={this.state.email}
            onChange={this.handleChange}
          />
        </FormControl>
        <Typography
          className="errorMsg"
          variant="caption"
          gutterBottom
          align="center"
          color="secondary"
          role="alert"
        >
          {forgotPasswordErrorMsg}
        </Typography>
        <FormControl fullWidth className="input-cntr">
          {resetPasswordInProgress ? (
            <div style={{ textAlign: "center" }}>
              <CircularProgress size={32} aria-label="Sending" />
            </div>
          ) : (
            <Button variant="raised" color="primary" className="box-btn" type="submit">
              <span style={{ color: "#FFF" }}>Send reset link</span>
            </Button>
          )}
        </FormControl>
      </form>
    );
  }

  renderSent() {
    return (
      <div className="loginform-cntr" role="status">
        <Typography gutterBottom>
          If an account exists for <strong>{this.state.email.trim()}</strong>, we've sent it a link to set a new password.
        </Typography>
        <Typography gutterBottom>
          Open the email, set your new password, then come back and sign in. If it doesn't arrive in a few
          minutes, check your spam folder.
        </Typography>
        <FormControl fullWidth className="input-cntr" style={{ marginTop: 16 }}>
          <Button variant="raised" color="primary" className="box-btn" component={toLogin}>
            <span style={{ color: "#FFF" }}>Back to sign in</span>
          </Button>
        </FormControl>
        <div style={{ textAlign: "center" }}>
          <Button onClick={this.tryAgain}>
            <Typography variant="caption">Didn't get it? Send again or use a different email</Typography>
          </Button>
        </div>
      </div>
    );
  }

  render() {
    const { passwordLinkSent } = this.props.auth;
    return (
      <div className="login-cntr">
        <div className="login-artifact">
          <img alt="Illumine Digital" src="/images/assets/logo-header.svg" height={56} />
        </div>
        <Typography variant="title" className="box-title" gutterBottom align="center" component="h1">
          {passwordLinkSent ? "Check your email" : "Reset your password"}
        </Typography>
        {passwordLinkSent ? this.renderSent() : this.renderForm()}
        {passwordLinkSent ? null : (
          <div className="login-link-cntr">
            <Button component={toLogin}>
              <Typography className="errorMsg" variant="caption" gutterBottom>
                Back to sign in
              </Typography>
            </Button>
            <Button component={toRegister}>
              <Typography className="errorMsg" variant="caption" gutterBottom color="primary">
                New user? Register
              </Typography>
            </Button>
          </div>
        )}
      </div>
    );
  }
};

ForgotPassword.propTypes = {
  auth: PropTypes.object,
  resetPassword: PropTypes.func,
  resetForgotPasswordPage: PropTypes.func
};

const mapStateToProps = state => ({
  auth: state.auth
});

function matchDispatchToProps(dispatch) {
  return bindActionCreators({ resetPassword, resetForgotPasswordPage }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(ForgotPassword);
